import Api from '@/modules/core/api/api.ts';
import { SystemEndPoint } from '@/modules/core/enums/system-end-point.enum.ts';
import { DateTime } from 'luxon';

export type GetDeadlineParameters = {
  days: number;
  from?: DateTime;
};

export type GetWorkDaysDiffParameters = {
  from: DateTime;
  to: DateTime;
};

export class DeadlineApi {
  static async getDeadline({ days, from = DateTime.now() }: GetDeadlineParameters, signal?: AbortSignal) {
    const response = await Api.post(
      SystemEndPoint.GetDeadline,
      {
        count_day: days,
        date_start: from.toSQLDate(),
      },
      signal
    );

    return DateTime.fromFormat(response.date as string, 'dd.MM.yyyy');
  }

  static async getWorkDaysDiff({ from, to }: GetWorkDaysDiffParameters, signal?: AbortSignal) {
    const response = await Api.post(
      SystemEndPoint.GetWorkDaysDiff,
      {
        date_start: from.toSQLDate(),
        date_end: to.toSQLDate(),
      },
      signal
    );

    return response.count_days as number;
  }
}
